// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5050":"a4c12cc8b2d1ce7f","8976":"c9fa6d3148d57306"}[chunkId] + ".css";
};